import React, { useState, useEffect, useContext } from 'react'
import ProfileCard from '../../../components/Connection/ProfileCard'
// import Loading from '../../../components/Loading/Index'
import Requests from '../../../utils/Requests/Index';
import { toast } from 'react-toastify'
//import 'react-toastify/dist/ReactToastify.css'
import { useQuery } from '@tanstack/react-query';
import { singleProContext } from '../../../utils/context/SingleProfileContext';
import { useSelector, useDispatch } from 'react-redux'
import { stopRefatch } from '../../../utils/Redux/Slice/RefatchSlice'
import { seenAcceptedProposal } from '../../../utils/Redux/Slice/NotificationSlice'

const Index = () => {
    const { handleLocalStoreIds } = useContext(singleProContext)
    const [isUpdate, setUpdate] = useState({ value: null, status: false })
    const [header] = useState({ headers: { Authorization: "Bearer " + localStorage.getItem('token') } })
    let [pageload, setPageload] = useState(true)
    const dispatch = useDispatch()
    const doRefatch = useSelector(state => state.refatch.sideEffect)
    const count = useSelector((state) => state.notification)

    // Fetch data   
    const fetchData = async () => {
        try {
            const response = await Requests.Connection.Accepted(header)
            if (response && response.users) {
                setPageload(false)
                dispatch(stopRefatch())
                return response.users
            }
        } catch (error) {
            setPageload(false)
        }
    }
    const { data, isLoading } = useQuery({
        queryKey: ['accepted'],
        queryFn: fetchData,
        retry: false,
        cacheTime: 600000,
        refetchOnWindowFocus: false,
        enabled: Boolean(pageload),
    });

    useEffect(() => {
        if (doRefatch) {
            setPageload(true)
        }
    }, [doRefatch]);

    useEffect(() => {
        const userIds = data?.map(info => info._id);
        handleLocalStoreIds(userIds);
    }, [data]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (window.location.pathname === '/connection/' && count.acceptedProposal > 0) {
            dispatch(seenAcceptedProposal())
        }
    }, [dispatch, count])

    // Update request type
    const Updatetype = async data => {
        try {
            setUpdate({ value: data, status: true })
            const response = await Requests.Connection.UpdateRequestType(data, "disconnect", header)
            if (response && response.status) {
                toast.success(response.message)
                setPageload(true)
            }
            setUpdate({ value: null, status: false })
        } catch (error) {
            if (error) console.log(error)
        }
    }

    // Update FavoriteList 
    const updateFavorite = async (user, type) => {
        try {
            const response = await Requests.Connection.UpdateFavoriteList(user, type, header)
            if (response?.status) {
                setPageload(true)
                toast.success(response.message)
            }
        } catch (error) {
            if (error) console.log(error);
        }
    }

    // if (isLoading) return <Loading />

    return (
        <div className="connection-container">
            {/* <ToastContainer autoClose={2000} /> */}
            <div className="container">
                <div className="row">
                    <div className="col-12 col-lg-6 text-center text-sm-left px-sm-4 mb-2">
                        <h6 className="mb-0">{data?.length} Accepted proposal</h6>
                        <small className="text-muted"><i>You have connected with {data?.length} peoples.</i></small>
                    </div>
                    {!isLoading &&
                    <div className="col-12">
                        {data && data.map((item, i) =>
                            <ProfileCard
                                key={i}
                                item={item}
                                buttonTitle="Disconnect"
                                changetype={Updatetype}
                                updateFavorite={updateFavorite}
                                favoriteShow={true}
                                loading={isUpdate}
                            />
                        )}
                    </div>}
                </div>
            </div>
        </div>
    );
};

export default Index;